import { useEffect, useState } from 'react';
import { Button, Modal, Form, Toast, ToastContainer } from 'react-bootstrap';
import { Pencil, Plus, BoxArrowInRight, ArrowRepeat, CollectionPlay } from 'react-bootstrap-icons';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import Multimedia from './MultimediaPage';
import api from '../api';

const Salas = () => {
  const [salas, setSalas] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedSala, setSelectedSala] = useState(null);
  const [errors, setErrors] = useState({});
  const [filteredSalas, setFilteredSalas] = useState([]);
  const [search, setSearch] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedSalaVideo, setSelectedSalaVideo] = useState(null);
  const userRole = localStorage.getItem('role');

  const normalizeText = (text) => {
    return text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // quita acentos
  };

  useEffect(() => {
    api.get('/salas').then(res => {
        setSalas(res.data)
        setFilteredSalas(res.data);
    });

    // Obtener servicios disponibles
    api.get('/empresas')
      .then(res => setEmpresas(res.data))
      .catch(err => console.error('Error cargando empresas:', err));

  }, []);

  // Opciones de empresas
  const opciones = empresas.map(empresa => ({
      value: empresa.id,
      label: empresa.nombre,
  }));

  useEffect(() => {
    const result = salas.filter(item =>
      normalizeText(item.nombre_sala)?.includes(normalizeText(search)) ||
      normalizeText(item.empresa?.nombre)?.includes(normalizeText(search))
    );
    setFilteredSalas(result);
  }, [search, salas]);

  const handleShowModal = (sala = {}) => {

    setSelectedSala({
      id: sala.id || null,
      nombre_sala: sala.nombre_sala || '',
      nombre_punto_atencion: sala.nombre_punto_atencion || null,
      numero_ventanillas: sala.numero_ventanillas || '',
      numero_servicios: sala.numero_servicios || '',
      estado: sala.estado !== undefined ? sala.estado : true,
      db_host: sala.db_host || '',
      db_port: sala.db_port || '3306',
      db_database: sala.db_database || '',
      db_username: sala.db_username || '',
      db_password: sala.db_password || '',
      empresa_id: sala.empresa_id || '',
      reporte_1_url: sala.reporte_1_url || '',
      reporte_2_url: sala.reporte_2_url || '',
      num_pantallas: sala.num_pantallas || 1,
      integracion: sala.integracion !== undefined ? sala.integracion : false,
      ver_quirofano: sala.ver_quirofano !== undefined ? sala.ver_quirofano : false,
      msj_suspension: sala.msj_suspension !== undefined ? sala.msj_suspension : false,
    });
    setErrors({});
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    setSelectedSala(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!selectedSala.empresa_id) newErrors.empresa_id = 'Seleccione una empresa.';
    if (!selectedSala.nombre_sala?.trim()) newErrors.nombre_sala = "Campo requerido";
    if (!selectedSala.nombre_punto_atencion?.trim()) newErrors.nombre_punto_atencion = "Campo requerido";
    if (!selectedSala.numero_ventanillas) newErrors.numero_ventanillas = "Campo requerido";
    if (!selectedSala.numero_servicios) newErrors.numero_servicios = "Campo requerido";
    if (!selectedSala.num_pantallas) newErrors.num_pantallas = "Campo requerido";
    if (!selectedSala.db_host) newErrors.db_host = "Campo requerido";
    if (!selectedSala.db_port) newErrors.db_port = "Campo requerido";
    if (!selectedSala.db_database?.trim()) newErrors.db_database = "Campo requerido";
    if (!selectedSala.db_username?.trim()) newErrors.db_username = "Campo requerido";
    if (!selectedSala.db_password?.trim()) newErrors.db_password = "Campo requerido";
    if (!selectedSala.numero_ventanillas || selectedSala.numero_ventanillas <= 0) newErrors.numero_ventanillas = 'Ingrese una cantidad válida.';
    if (!selectedSala.numero_servicios || selectedSala.numero_servicios <= 0) newErrors.numero_servicios = 'Ingrese una cantidad válida.';
    if (!selectedSala.num_pantallas || selectedSala.num_pantallas <= 0) newErrors.num_pantallas = 'Ingrese una cantidad válida.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;

    setIsSaving(true);
    const isEdit = !!selectedSala.id;
    const request = isEdit
      ? api.put(`/salas/${selectedSala.id}`, selectedSala)
      : api.post('/salas', selectedSala);

    request
      .then(res => {
        const actualizada = res.data.data;
        const listaNueva = isEdit
          ? salas.map(s => s.id === actualizada.id ? actualizada : s)
          : [...salas, actualizada];

        setSalas(listaNueva);
        setShowModal(false);
        setToast({ show: true, variant: 'success', message: `Sala ${isEdit ? 'actualizada' : 'creada'} correctamente.` });
      })
      .catch(err => {
        if (err.response?.data?.errors) {
          setErrors(err.response.data.errors);
          setToast({ show: true, variant: 'danger', message: 'No se pudo guardar la sala.' });
        }
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleEntrar = async (sala) => {
    const config = {
      db_host: sala.db_host,
      db_port: sala.db_port,
      db_database: sala.db_database,
      db_username: sala.db_username,
      db_password: sala.db_password,
    };

    const encodedConfig = btoa(JSON.stringify(config));

    // Guardar en localStorage y actualizar header en instancia api
    localStorage.setItem('mariadb_config', encodedConfig);
    localStorage.setItem('numservicios', sala.numero_servicios);
    localStorage.setItem('numventanillas', sala.numero_ventanillas);
    localStorage.setItem('namesala', sala.nombre_sala);
    localStorage.setItem('id_sala', sala.id);
    localStorage.setItem('url_principal', sala.reporte_1_url);
    localStorage.setItem('url_secundario', sala.reporte_2_url);
    api.defaults.headers.common['X-MariaDB-Config'] = encodedConfig;

    try {
      await api.get('/servicios'); // fuerza validación
      window.location.href = '/home';
    } catch (error) {
      setToast({
        show: true,
        variant: 'danger',
        message: 'No se pudo establecer conexión con la sala. Por favor comuníquese con soporte al correo siteturnos@sitesas.com.',
      });
    }
  };

  const handleRefresh = async (row) => {
    const config = {
      db_host: row.db_host,
      db_port: row.db_port,
      db_database: row.db_database,
      db_username: row.db_username,
      db_password: row.db_password,
    };

    const encodedConfig = btoa(JSON.stringify(config));

    try {
      await api.post('/refrescar-sala', {}, {
        headers: {
          'X-MariaDB-Config': encodedConfig
        }
      });
      
      setToast({ show: true, variant: 'success', message: 'Refrescado correctamente' });
    } catch (err) {
      setToast({
        show: true,
        variant: 'danger',
        message: 'No se pudo establecer conexión con la sala. Por favor comuníquese con soporte al correo siteturnos@sitesas.com.',
      });
    }
  }

  const handleVideoManager = (row) => {
    setSelectedSalaVideo(row);
    setShowVideoModal(true);
  }

  const customStyles = {
    headCells: {
      style: {
        justifyContent: 'flex-start',
        textAlign: 'left',
      },
    },
    cells: {
      style: {
        justifyContent: 'flex-start',
        textAlign: 'left',
      },
    },
  };

  const columns = [
    { name: 'Empresa', selector: row => row.empresa?.nombre, sortable: true},
    { name: 'Id Sala', selector: row => row.id, sortable: true, width: '90px'},
    { name: 'Nombre Sala', selector: row => row.nombre_sala, sortable: true},
    { name: '# Ventanillas', selector: row => row.numero_ventanillas, width: '120px'},
    { name: '# Servicios', selector: row => row.numero_servicios, width: '120px' },
    { name: 'Estado', 
      selector: row => row.estado,
      cell: row => (
        <Form.Check
          type="switch"
          id={`switch-${row.id}`}
          checked={row.estado === true}
          disabled
          readOnly
        />
      ),
      ignoreRowClick: true,
      button: true,
      width: '90px'
    },
    {
      name: 'Opciones',
      cell: row => (
        <div className="d-flex gap-2">
          {userRole === 'admin' && (
            <Button variant="outline-primary" size="sm" onClick={() => handleShowModal(row)}>
              <Pencil />
            </Button>
          )}
          {userRole !== 'consulta' && (
            <Button
              variant="outline-warning"
              size="sm"
              title='Refrescar'
              onClick={() => handleRefresh(row)} 
            >
              <ArrowRepeat />
            </Button>
          )}
          {userRole !== 'consulta' && (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => handleVideoManager(row)} 
            >
              <CollectionPlay />
            </Button>
          )}
          {row.estado !== false && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleEntrar(row)} 
            >
              <BoxArrowInRight />
            </Button>
          )}
        </div>
      ),
   
    },
  ];

  return (
    <div className="mt-4">
      <DataTable
        title="Listado de Salas"
        columns={columns}
        customStyles={customStyles}
        data={filteredSalas}
        pagination
        highlightOnHover
        responsive
        striped
        subHeader={userRole === 'admin'}
        subHeaderComponent={
          <div className="d-flex justify-content-between w-100">
            <Button variant="outline-success" size="sm" onClick={() => handleShowModal()}>
              Nuevo <Plus />
            </Button>
            <input
                type="text"
                className="form-control w-25"
                placeholder="Buscar..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
          </div>
        }
      />

      {/* Modal de Formulario */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedSala?.id ? 'Editar Sala' : 'Nueva Sala'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedSala && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Empresa</Form.Label>
                <div className={errors.empresa_id ? 'is-invalid' : ''}>
                  <Select
                    name="empresa_id"
                    options={opciones}
                    value={opciones.find(opt => opt.value === selectedSala.empresa_id) || null}
                    onChange={selected => setSelectedSala({ ...selectedSala, empresa_id: selected.value })}
                  />
                </div>
                {errors.empresa_id && (
                  <div className="invalid-feedback d-block">{errors.empresa_id}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nombre Sala</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_sala"
                  value={selectedSala.nombre_sala}
                  onChange={handleInputChange}
                  isInvalid={!!errors.nombre_sala}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nombre_sala}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nombre general para los puntos de atención</Form.Label>
                <div className={errors.nombre_punto_atencion ? 'is-invalid' : ''}>
                  <Select
                  name="nombre_punto_atencion"
                  options={[
                    { value: 'Módulo', label: 'Módulo'},
                    { value: 'Ventanilla', label: 'Ventanilla' },
                    { value: 'Caja', label: 'Caja' }
                  ]}
                  value={[
                    { value: 'Módulo', label: 'Módulo'},
                    { value: 'Ventanilla', label: 'Ventanilla' },
                    { value: 'Caja', label: 'Caja' }
                  ].find(opt => opt.value === selectedSala?.nombre_punto_atencion) || null}
                  onChange={selected => setSelectedSala({ ...selectedSala, nombre_punto_atencion: selected.value })}
                />
                </div>
                {errors.nombre_punto_atencion && (
                  <div className="invalid-feedback d-block">{errors.nombre_punto_atencion}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Número de ventanillas</Form.Label>
                <Form.Control
                  type="number"
                  name="numero_ventanillas"
                  value={selectedSala.numero_ventanillas}
                  min={1}
                  onChange={handleInputChange}
                  isInvalid={!!errors.numero_ventanillas}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.numero_ventanillas}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Número de servicios</Form.Label>
                <Form.Control
                  type="number"
                  name="numero_servicios"
                  value={selectedSala.numero_servicios}
                  min={1}
                  onChange={handleInputChange}
                  isInvalid={!!errors.numero_servicios}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.numero_servicios}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Número de pantallas</Form.Label>
                <Form.Control
                  type="number"
                  name="num_pantallas"
                  value={selectedSala.num_pantallas}
                  min={1}
                  onChange={handleInputChange}
                  isInvalid={!!errors.num_pantallas}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.num_pantallas}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Host BD</Form.Label>
                <Form.Control
                  type="text"
                  name="db_host"
                  value={selectedSala.db_host}
                  onChange={handleInputChange}
                  isInvalid={!!errors.db_host}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.db_host}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Puerto BD</Form.Label>
                <Form.Control
                  type="text"
                  name="db_port"
                  value={selectedSala.db_port}
                  onChange={handleInputChange}
                  isInvalid={!!errors.db_port}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.db_port}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nombre BD</Form.Label>
                <Form.Control
                  type="text"
                  name="db_database"
                  value={selectedSala.db_database}
                  onChange={handleInputChange}
                  isInvalid={!!errors.db_database}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.db_database}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Usuario BD</Form.Label>
                <Form.Control
                  type="text"
                  name="db_username"
                  value={selectedSala.db_username}
                  onChange={handleInputChange}
                  isInvalid={!!errors.db_username}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.db_username}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Contraseña BD</Form.Label>
                <Form.Control
                  type="text"
                  name="db_password"
                  value={selectedSala.db_password}
                  onChange={handleInputChange}
                  isInvalid={!!errors.db_password}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.db_password}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>URL reporte principal</Form.Label>
                <Form.Control
                  type="text"
                  name="reporte_1_url"
                  value={selectedSala.reporte_1_url}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>URL reporte secundario</Form.Label>
                <Form.Control
                  type="text"
                  name="reporte_2_url"
                  value={selectedSala.reporte_2_url}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  label="Estado"
                  name="estado"
                  checked={selectedSala.estado === true}
                  disabled={selectedSala?.id ? false : true}
                  onChange={(e) =>
                    setSelectedSala({
                      ...selectedSala,
                      estado: e.target.checked ? true : false,
                    })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  label="Integrar"
                  name="integracion"
                  checked={selectedSala.integracion === true}
                  onChange={(e) =>
                    setSelectedSala({
                      ...selectedSala,
                      integracion: e.target.checked ? true : false,
                    })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  label="Mostrar Quirófano"
                  name="ver_quirofano"
                  checked={selectedSala.ver_quirofano === true}
                  onChange={(e) =>
                    setSelectedSala({
                      ...selectedSala,
                      ver_quirofano: e.target.checked ? true : false,
                    })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  label="Mostrar Msj de Suspensión"
                  name="msj_suspension"
                  checked={selectedSala.msj_suspension === true}
                  onChange={(e) =>
                    setSelectedSala({
                      ...selectedSala,
                      msj_suspension: e.target.checked ? true : false,
                    })
                  }
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleSave} disabled={isSaving}>{isSaving ? 'Guardando...' : 'Guardar'}</Button>
        </Modal.Footer>
      </Modal>

    {/* Modal Video Manager */}
      <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Gestión de Videos - {selectedSalaVideo?.nombre_sala}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Multimedia sala={selectedSalaVideo} setToast={setToast} />
        </Modal.Body>
      </Modal>

      {/* Toast */}
      <ToastContainer position="top-end" className="p-3">
        <Toast bg={toast.variant} onClose={() => setToast({ ...toast, show: false })} show={toast.show} delay={30000} autohide>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Salas;
